// src/redux/settingsPages/language/languageActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import LanguageAPI from './languageAPi';

export const fetchAvailableLanguages = createAsyncThunk(
  'language/fetchAvailable',
  async (_, { rejectWithValue }) => {
    try {
      return await LanguageAPI.getAvailableLanguages();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load languages');
    }
  }
);

export const fetchUserLanguage = createAsyncThunk(
  'language/fetchCurrent',
  async (_, { rejectWithValue }) => {
    try {
      return await LanguageAPI.getUserLanguage();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load current language');
    }
  }
);

export const updateUserLanguage = createAsyncThunk(
  'language/updateCurrent',
  async (code, { rejectWithValue }) => {
    try {
      return await LanguageAPI.setUserLanguage(code);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update language');
    }
  }
);
